module.exports = __webpack_public_path__ + "img/21.b72a714d.jpg";